import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Box, CardActionArea, Grid, Typography } from '@mui/material';
import { useLocales } from 'src/locales';
import Iconify from 'src/components/iconify/Iconify';
import { Stack, padding } from '@mui/system';
import React from 'react';
import { Card, CardContent } from '@mui/material';
import { Icon } from '@iconify/react';
import { createOdooURL } from '../../routes/odooURL';

export default function ApplicationsPage() {
  const { translate } = useLocales();

  type IconifyIcon = string;

  interface CardData {
    icon: IconifyIcon;
    title: string;
    description: string;
    url?: string;
  }

  const cardsRH: CardData[] = [
    {
      icon: 'mdi:account-group', // Icône représentant un groupe d'employés
      title: `${translate('upComingAppsPage.hr.employee.title')}`,
      description: `${translate('upComingAppsPage.hr.employee.description')}`,
      url: createOdooURL('employees'),
    },
    {
      icon: 'mdi:account-search', // Icône représentant une loupe pour la recherche
      title: `${translate('upComingAppsPage.hr.recruitment.title')}`,
      description: `${translate(
        'upComingAppsPage.hr.recruitment.description'
      )}`,
      url: createOdooURL('recruitment'),
    },
    {
      icon: 'mdi:calendar-clock', // Icône représentant une horloge et un calendrier pour les congés
      title: `${translate('upComingAppsPage.hr.leaves.title')}`,
      description: `${translate('upComingAppsPage.hr.leaves.description')}`,
      url: createOdooURL('leaves'),
    },
  ];

  return (
    <>
      <Helmet>
        <title> {`${translate('upComingAppsPage.title')}`} </title>
      </Helmet>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '100vh' }}
      >
        <Grid item>
          <Typography
            variant="h3"
            paragraph
            align="center"
            sx={{ marginTop: '70px', marginBottom: '100px' }}
          >
            {`${translate('upComingAppsPage.appList')}`}
          </Typography>

          <Grid container spacing={12} sx={{ maxWidth: '1000px' }}>

            <Grid item>
              <Typography variant="h4" paragraph>
                {`${translate('upComingAppsPage.hr.title')}`}
              </Typography>

              <Typography sx={{ marginBottom: '20px' }}>
                {`${translate('upComingAppsPage.hr.description')}`}
              </Typography>

              <Grid container spacing={2}>
                {cardsRH.map((card, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card>
                      <CardActionArea
                        component="a"
                        href={card.url}
                        target="_bank"
                      >
                        <CardContent
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          <div>
                            <Icon
                              icon={card.icon}
                              width={32}
                              style={{ marginRight: 16 }}
                            />
                          </div>
                          <div>
                            <Typography variant="h6">{card.title}</Typography>
                            <Typography variant="body2" color="textSecondary">
                              {card.description}
                            </Typography>
                          </div>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>

          <Typography variant="h4" sx={{ marginTop: '80px' }} align="center">
            {`${translate('upComingAppsPage.footer.line1')}`} <br />
            {`${translate('upComingAppsPage.footer.line2')}`}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
